import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification, DatePicker, Space, message, Card, Pagination, Select } from "antd";
import jsPDF from 'jspdf';
import { Row, Form, Col } from "antd";
import { DownloadOutlined, FilterOutlined, ClearOutlined, SearchOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx';

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import dayjs from "dayjs";
import WasteApi from "../common/Apis/WasteApi";

const WasteReports = () => {
    const { Content } = Layout;
    const [formAdd] = Form.useForm();
    const [WasteReport, setWasteReport] = React.useState([]);
    const [filteredReport, setFilteredReport] = React.useState([]);
    const [WasteCurrency, setWasteCurrency] = React.useState();
    const [exportLoading, setExportLoading] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";

    // Filter states
    const [cookNameFilter, setCookNameFilter] = useState(null);
    const [batchCodeFilter, setBatchCodeFilter] = useState(null);

    // Filter options
    const [cookNameOptions, setCookNameOptions] = useState([]);
    const [batchCodeOptions, setBatchCodeOptions] = useState([]);

    const [TotalQuantity, setTotalQuantity] = React.useState();
    const [productionCoast, setproductionCoast] = React.useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(30);

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    // Extract unique filter options from data
    const extractFilterOptions = (data) => {
        const cookNames = new Set();
        const batchCodes = new Set();

        data.forEach((item) => {
            // Cook Name - from cookName field
            if (item?.cookName) {
                cookNames.add(item.cookName);
            }
            // Batch Code - from productionDTO.batchCode
            if (item?.productionDTO?.batchCode) {
                batchCodes.add(item.productionDTO.batchCode);
            }
        });

        setCookNameOptions(Array.from(cookNames).sort());
        setBatchCodeOptions(Array.from(batchCodes).sort());
    };

    // Apply filters to data
    const applyFilters = useCallback(() => {
    let filtered = [...WasteReport];

    if (cookNameFilter) {
        filtered = filtered.filter(
            item => item?.cookName === cookNameFilter
        );
    }

    if (batchCodeFilter) {
        filtered = filtered.filter(
            item => item?.productionDTO?.batchCode === batchCodeFilter
        );
    }

    setFilteredReport(filtered);
    setCurrentPage(1);

    // Update dropdowns based on current filtered result
    const cookNames = [...new Set(filtered.map(x => x?.cookName).filter(Boolean))];
    const batchCodes = [...new Set(filtered.map(x => x?.productionDTO?.batchCode).filter(Boolean))];

    setCookNameOptions(cookNames.sort());
    setBatchCodeOptions(batchCodes.sort());

}, [WasteReport, cookNameFilter, batchCodeFilter]);

    // Reset filters
    const resetFilters = () => {
    setCookNameFilter(null);
    setBatchCodeFilter(null);
    setFilteredReport(WasteReport);
    extractFilterOptions(WasteReport);
    setCurrentPage(1);
};

    const handlePrintButtonClick2 = () => {
        const windowWidth = window.innerWidth * 0.264583; 
        const windowHeight = window.innerHeight * 0.264583;

        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [windowWidth, windowHeight]
        });

        const fontSize = 12;
        const margin = 5;
        const cellWidthFactor = 0.318;
        const cellHeightFactor = 0.2;

        doc.setFontSize(fontSize);

        const table = document.querySelector('.table');
        const rows = table.querySelectorAll('tr');

        // Set page title
        const pageTitle = 'Waste Reports';
        const pageTitleWidth = doc.getStringUnitWidth(pageTitle) * fontSize / doc.internal.scaleFactor;
        const pageTitleXPos = (doc.internal.pageSize.width - pageTitleWidth) / 2;
        doc.text(pageTitleXPos, margin, pageTitle);

        doc.setFontSize(fontSize);
        const currentDate = new Date().toLocaleString();
        const dateTimeWidth = doc.getStringUnitWidth(currentDate) * fontSize / doc.internal.scaleFactor;
        const dateTimeXPos = doc.internal.pageSize.width - margin - dateTimeWidth;
        doc.text(dateTimeXPos, margin, currentDate);

        let yPos = margin + fontSize;

        rows.forEach((row, rowIndex) => {
            const cells = row.querySelectorAll('th, td');
            let xPos = margin;

            cells.forEach((cell, cellIndex) => {
                const cellText = cell.textContent.trim();
                const cellWidth = cell.offsetWidth * cellWidthFactor;
                const cellHeight = row.offsetHeight * cellHeightFactor;

                if (yPos + cellHeight > doc.internal.pageSize.height - margin) {
                    doc.addPage();
                    yPos = margin + fontSize;
                    const pageTitle = 'Waste Reports';
                    const pageTitleWidth = doc.getStringUnitWidth(pageTitle) * fontSize / doc.internal.scaleFactor;
                    const pageTitleXPos = (doc.internal.pageSize.width - pageTitleWidth) / 2;
                    doc.text(pageTitleXPos, margin, pageTitle);

                    doc.setFontSize(fontSize);
                    const currentDate = new Date().toLocaleString();
                    const dateTimeWidth = doc.getStringUnitWidth(currentDate) * fontSize / doc.internal.scaleFactor;
                    const dateTimeXPos = doc.internal.pageSize.width - margin - dateTimeWidth;
                    doc.text(dateTimeXPos, margin, currentDate);
                }

                const isHeader = cell.tagName.toLowerCase() === 'th';
                const fontWeight = isHeader ? 'bold' : 'normal';
                const isLastColumn = cellIndex === cells.length - 1;

                doc.setFont(undefined, fontWeight);

                const textWidth = doc.getStringUnitWidth(cellText) * fontSize / doc.internal.scaleFactor;
                const cellPadding = 2;
                let xPosAlign = xPos + (cellWidth - textWidth - cellPadding) / 2;

                if (!isHeader) {
                    xPosAlign = xPos;
                    if (isLastColumn) {
                        xPosAlign = xPos + (cellWidth - textWidth) / 2;
                    }
                }
                doc.rect(xPos, yPos, cellWidth, cellHeight);
                doc.text(xPosAlign + 1, yPos + 5, cellText);

                xPos += cellWidth;
            });

            yPos += row.offsetHeight * cellHeightFactor;
        });

        window.open(doc.output('bloburl'), '_blank');
    };

    // Function to handle export to Excel
    const handleExportToExcel = () => {
        const displayData = filteredReport.length > 0 ? filteredReport : WasteReport;
        
        if (!displayData || displayData.length === 0) {
            message.warning("No data available to export");
            return;
        }

        setExportLoading(true);
        
        try {
            const excelData = [];

            // Add data rows
            displayData.forEach((date, index) => {
                excelData.push({
                    'Date': formatDate(date.createdDate),
                    'Batch Code': date?.productionDTO?.batchCode || '-',
                    'Product Description': date?.productionName || '-',
                    'Production Qty': `${date?.productionDTO?.quantity || 0} ${date?.productionDTO?.unit || ''}`,
                    'Wasted By': date?.cookName || '-',
                    'Reason': date?.reason || '-',
                    'Wasted Qty': `${(() => {
                        const value = Number(date?.quantity || 0);

                        const normalStr = value.toLocaleString("fullwide", {
                            useGrouping: false,
                            maximumFractionDigits: 20,
                        });

                        const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);

                        return match ? match[0] : "0";
                    })()} ${date?.unit || ''}`,
                    'Cost': `${date.productionDTO?.currency || ''} ${CurrencyConvert(parseFloat(date?.productionCoast || 0))}`
                });
            });

            // Calculate totals for filtered data
            let filteredTotalQuantity = 0;
            let filteredProductionCoast = 0;
            
            displayData.forEach((item) => {
                filteredTotalQuantity += (item?.quantity || 0);
                filteredProductionCoast += (parseFloat(item?.productionCoast) || 0);
            });

            // Add summary rows
            excelData.push({
                'Date': '',
                'Batch Code': '',
                'Product Description': 'TOTAL',
                'Production Qty': '',
                'Wasted By': '',
                'Reason': '',
                'Wasted Qty': `${(() => {
                    const value = Number(filteredTotalQuantity || 0);

                    const normalStr = value.toLocaleString("fullwide", {
                        useGrouping: false,
                        maximumFractionDigits: 20,
                    });

                    const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);

                    return match ? match[0] : "0";
                })()} ${displayData[0]?.unit || ''}`,
                'Cost': `${WasteCurrency || ''} ${CurrencyConvert(filteredProductionCoast || 0)}`
            });

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(excelData);

            // Set column widths
            const colWidths = [
                { wch: 15 },  // Date
                { wch: 15 },  // Batch Code
                { wch: 25 },  // Product Description
                { wch: 15 },  // Production Qty
                { wch: 15 },  // Wasted By
                { wch: 20 },  // Reason
                { wch: 15 },  // Wasted Qty
                { wch: 15 }   // Cost
            ];
            ws['!cols'] = colWidths;

            // Style the header row
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const address = XLSX.utils.encode_col(C) + '1';
                if (!ws[address]) continue;
                ws[address].s = {
                    font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
                    fill: { fgColor: { rgb: "4F81BD" }, patternType: "solid" },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

            // Style the summary row
            const lastRow = excelData.length;
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const address = XLSX.utils.encode_col(C) + lastRow;
                if (!ws[address]) continue;
                ws[address].s = {
                    font: { bold: true, sz: 11 },
                    fill: { fgColor: { rgb: "FFC000" }, patternType: "solid" },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Waste Report");

            // Get date range for filename
            const startDate = formAdd.getFieldValue('startDate');
            const endDate = formAdd.getFieldValue('endDate');
            let fileName = `Waste_Report_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
            
            if (startDate && endDate) {
                const startStr = dayjs(startDate).format('YYYY-MM-DD');
                const endStr = dayjs(endDate).add(24, "hours").format('YYYY-MM-DD');
                fileName = `Waste_Report_${startStr}_to_${endStr}.xlsx`;
            }

            // Save file
            XLSX.writeFile(wb, fileName);
            
            message.success("Waste report exported successfully!");
        } catch (error) {
            console.error("Error exporting waste report:", error);
            message.error("Failed to export waste report");
        } finally {
            setExportLoading(false);
        }
    };

    const fetchAllWasteReportPages = async (startDate, endDate) => {
    const pageSize = 30;

    // First request - get the first page and totalPages
    const firstResponse = await WasteApi.ListproductWasteReport(
        startDate,
        endDate,
        0,
        pageSize
    );

    const totalPages = firstResponse?.totalPages || 1;

    let allData = [...(firstResponse?.payloadDto || [])];

    // Fetch remaining pages
    for (let page = 1; page < totalPages; page++) {
        const response = await WasteApi.ListproductWasteReport(
        startDate,
        endDate,
        page,
        pageSize
        );

        if (response?.payloadDto?.length) {
        allData = [...allData, ...response.payloadDto];
        }
    }

    return {
        ...firstResponse,
        payloadDto: allData,
        totalElements: allData.length,
        totalPages,
    };
    };

    const getCurrent = useCallback(() => {
    const todayDate = dayjs().format('DD/MM/YYYY');
    const tomorrowDate = dayjs().add(1, 'day').format('DD/MM/YYYY');

    formAdd.setFieldsValue({
        startDate: dayjs(todayDate, 'DD/MM/YYYY'),
        endDate: dayjs(tomorrowDate, 'DD/MM/YYYY'),
    });

    fetchAllWasteReportPages(
        convertToUnixTimestamp(todayDate),
        convertToUnixTimestamp(tomorrowDate) + (24 * 60 * 60 * 1000)
    )
        .then((response) => {
        PageLoading();

        const reportData = response?.payloadDto || [];

        setWasteReport(reportData);
        setWasteCurrency(reportData[0]?.productionDTO?.currency);

        if (reportData.length) {
            extractFilterOptions(reportData);

            const totalQuantity = reportData.reduce(
            (total, item) => total + (item?.quantity || 0),
            0
            );

            setTotalQuantity(totalQuantity);

            const productionCoast = reportData.reduce(
            (total, item) =>
                total + (parseFloat(item?.productionCoast) || 0),
            0
            );

            setproductionCoast(productionCoast);
        }
        })
        .catch((err) => {
        console.log(err);

        if (err.apiError?.status) {
            notification.open({
            message: (
                <span style={{ fontWeight: "bold" }}>
                {err.apiError.status}
                </span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
                backgroundColor: "#fff2f0",
                color: "red",
            },
            });
        }
        });
    }, []);
    
    useEffect(() => {
        PageLoading();
        getCurrent();
    }, [PageLoading, getCurrent]);

    // Apply filters when filter values change or data changes
    useEffect(() => {
    applyFilters();
}, [WasteReport, cookNameFilter, batchCodeFilter]);

    const formRef = useRef(null);

    const handleSubmit = (data) => {
    setFilterLoading(true);

    const startDateN = dayjs(data.startDate).format("DD/MM/YYYY");
    const endDateN = dayjs(data.endDate).add(24, "hours").format("DD/MM/YYYY");

    fetchAllWasteReportPages(
        convertToUnixTimestamp(startDateN),
        convertToUnixTimestamp(endDateN)
    )
        .then((response) => {
        PageLoading();

        const reportData = response?.payloadDto || [];

        setWasteReport(reportData);
        setWasteCurrency(reportData[0]?.productionDTO?.currency);

        if (reportData.length) {
            extractFilterOptions(reportData);

            const totalQuantity = reportData.reduce(
            (total, item) => total + (item?.quantity || 0),
            0
            );

            setTotalQuantity(totalQuantity);

            const productionCoast = reportData.reduce(
            (total, item) =>
                total + (parseFloat(item?.productionCoast) || 0),
            0
            );

            setproductionCoast(productionCoast);
        }

        setFilterLoading(false);
        })
        .catch((err) => {
        console.log(err);
        setFilterLoading(false);

        if (err.apiError?.status) {
            notification.open({
            message: (
                <span style={{ fontWeight: "bold" }}>
                {err.apiError.status}
                </span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
                backgroundColor: "#fff2f0",
                color: "red",
            },
            });
        }
        });
    };
    
    function formatDate(date) {
        if (!date) return '-';
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    const handleClear = () => {
        setIsLoading(true);
        setproductionCoast(null);
        setTotalQuantity(null);
        setWasteReport([]);
        setFilteredReport([]);
        setWasteCurrency(null);
        resetFilters();
        setTimeout(() => {
            getCurrent();
            setIsLoading(false);
        }, 800);
    };

    const CurrencyConvert = (value) => {
        const formattedNumber = new Intl.NumberFormat('en-US').format(value);
        return formattedNumber;
    };

    // Determine which data to display
    const displayData = filteredReport.length > 0 ? filteredReport : WasteReport;

    const totalResultPages = Math.ceil(displayData.length / pageSize);

    const sortedDisplayData = [...displayData].sort(
        (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
        );

    const paginatedData = sortedDisplayData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
        );

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader onPrintResponse2={handlePrintButtonClick2} />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}

                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        {/* Filter Section - Separated Card */}
                        <Card 
                            style={{ 
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '10px' }}>
                                <Space>
                                    <FilterOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Filter Options</span>
                                </Space>
                            </div>
                            
                            <Form
                                form={formAdd}
                                name="waste_filter_form"
                                layout="vertical"
                                onFinish={handleSubmit}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            name="startDate"
                                            label="Start Date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please Select Start Date.",
                                                },
                                            ]}
                                        >
                                            <DatePicker
                                                format={"DD/MM/YYYY"}
                                                placeholder="Select start date"
                                                style={{ width: '100%', height: '40px' }}
                                                allowClear={false}
                                                suffixIcon={null}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            name="endDate"
                                            label="End Date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please Select End Date.",
                                                },
                                            ]}
                                        >
                                            <DatePicker
                                                format={"DD/MM/YYYY"}
                                                placeholder="Select end date"
                                                style={{ width: '100%', height: '40px' }}
                                                allowClear={false}
                                                suffixIcon={null}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={8} md={24} sm={24} xs={24}>
                                        <Form.Item label="Actions">
                                            <Space size="middle" wrap>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    loading={filterLoading}
                                                    icon={<FilterOutlined />}
                                                    style={{ height: '40px', minWidth: '100px' }}
                                                >
                                                    Apply Filter
                                                </Button>
                                                <Button
                                                    onClick={() => handleClear()}
                                                    icon={<ClearOutlined />}
                                                    style={{ height: '40px', minWidth: '100px' }}
                                                >
                                                    Clear
                                                </Button>
                                            </Space>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>

                        {/* Advanced Filters Section - Wasted By & Batch Code */}
                        <Card 
                            style={{ 
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                background: '#fafafa'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '10px' }}>
                                <Space>
                                    <SearchOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Advanced Filters</span>
                                    <span style={{ fontSize: '12px', color: '#999' }}>
                                        (Filter by Wasted By or Batch Code)
                                    </span>
                                </Space>
                            </div>
                            
                            <Row gutter={[16, 16]}>
                                <Col lg={6} md={12} sm={24} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        Wasted By (Cook Name)
                                    </div>
                                    <Select
                                        placeholder="All Cooks"
                                        style={{ width: '100%' }}
                                        value={cookNameFilter}
                                        onChange={setCookNameFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {cookNameOptions.map(cookName => (
                                            <Select.Option key={cookName} value={cookName}>{cookName}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                                
                                <Col lg={6} md={12} sm={24} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        Batch Code
                                    </div>
                                    <Select
                                        placeholder="All Batch Codes"
                                        style={{ width: '100%' }}
                                        value={batchCodeFilter}
                                        onChange={setBatchCodeFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {batchCodeOptions.map(batchCode => (
                                            <Select.Option key={batchCode} value={batchCode}>{batchCode}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                                
                                <Col lg={12} md={24} sm={24} xs={24} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <Button
                                        onClick={resetFilters}
                                        icon={<ClearOutlined />}
                                        style={{ height: '32px' }}
                                    >
                                        Reset Filters
                                    </Button>
                                </Col>
                            </Row>
                            
                            <div style={{ marginTop: '12px', padding: '8px 12px', background: '#e6f7ff', borderRadius: '4px', fontSize: '12px', color: '#1890ff' }}>
                                Showing {displayData.length} of {WasteReport.length} records
                                {(cookNameFilter || batchCodeFilter) && 
                                    ` (Filtered: ${cookNameFilter ? `Wasted By: ${cookNameFilter}` : ''}${batchCodeFilter ? `, Batch: ${batchCodeFilter}` : ''})`
                                }
                            </div>
                        </Card>

                        {/* Report Results Section */}
                        <Card 
                            style={{ 
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ 
                                marginBottom: '16px', 
                                borderBottom: '1px solid #f0f0f0', 
                                paddingBottom: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <Space>
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Waste Report Results</span>
                                    <span style={{ fontSize: '12px', color: '#999' }}>
                                        {displayData.length > 0 && `(${displayData.length} records found)`}
                                    </span>
                                </Space>
                                <Button
                                    type="primary"
                                    onClick={handleExportToExcel}
                                    loading={exportLoading}
                                    icon={<DownloadOutlined />}
                                    style={{ 
                                        height: '36px',
                                        backgroundColor: '#52c41a',
                                        borderColor: '#52c41a'
                                    }}
                                >
                                    Export Waste Report
                                </Button>
                            </div>
                            
                            <div className="dateFilterTable" style={{ overflowX: 'auto' }}>
                                <table className="table users-table Reportable" style={{ width: '100%', minWidth: '800px' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan="8" className="text-center" style={{ fontSize: '16px', padding: '12px' }}>
                                                Waste Product
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Date</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Batch Code</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Product Description</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Production Qty</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Wasted By</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }}>Reason</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }} className="text-end">Wasted Qty</th>
                                            <th style={{ padding: '12px', textAlign: 'center' }} className="text-end">Cost</th>
                                        </tr>

                                        {displayData.length > 0 ? (
                                            <>
                                                {paginatedData.map((date, index) => {
                                                    let filteredTotalQuantity = 0;
                                                    let filteredProductionCoast = 0;
                                                    
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ width: '13%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                {formatDate(date.createdDate)}
                                                            </td>
                                                            <td style={{ width: '20%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                <div style={{
                                                                overflowX: 'auto',
                                                                overflowY: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '200px',
                                                                marginBottom: '10px',
                                                                marginTop: '-3px',
                                                                padding: '0px 0px 20px',
                                                                display: 'block',
                                                                }}>    
                                                                {date?.productionDTO?.batchCode || '-'}
                                                                </div>  
                                                            </td>
                                                            <td style={{ width: '20%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                {date?.productionName || '-'}
                                                            </td>
                                                            
                                                            <td style={{ width: '10%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                {(function () {
                                                                    const value = parseFloat(date?.productionDTO?.quantity || 0);

                                                                    const normalStr = value.toLocaleString('fullwide', {
                                                                        useGrouping: false,
                                                                        maximumFractionDigits: 20
                                                                    });

                                                                    const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);

                                                                    return match ? match[0] : '0';
                                                                })()} {date?.productionDTO?.unit || ''}
                                                            </td>
                                                            <td style={{ width: '10%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                {date.createdBy || '-'}
                                                            </td>
                                                             <td style={{ width: '20%', padding: '10px' }} className="CleanTable text-start text-center">
                                                                {date?.reason || '-'}
                                                            </td>
                                                            <td style={{ width: '10%', padding: '10px' }} className="CleanTable text-end text-center">
                                                                {(() => {
                                                                    const value = Number(date?.quantity || 0);

                                                                    const normalStr = value.toLocaleString("fullwide", {
                                                                        useGrouping: false,
                                                                        maximumFractionDigits: 20,
                                                                    });

                                                                    const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);

                                                                    return `${match ? match[0] : "0"} ${date?.unit || ''}`;
                                                                })()}
                                                            </td>
                                                            <td style={{ width: '10%', padding: '10px' }} className="CleanTable text-end text-center">
                                                                {CURRENCY || ''} {CurrencyConvert(parseFloat(date?.productionCoast || 0))}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr style={{ backgroundColor: '#f0f2f5', fontWeight: 'bold', textAlign: 'center' }}>
                                                <th colSpan={6} className="text-end text-center" style={{ padding: '12px', fontSize: '20px'}}>
                                                    Total
                                                </th>

                                                <th
                                                    colSpan={2}
                                                    className="text-end"
                                                    style={{ padding: '12px', fontSize: '20px' }}
                                                >
                                                    {CURRENCY || ''} {
                                                        (() => {
                                                            const totalCost = displayData.reduce(
                                                                (sum, item) => sum + (parseFloat(item?.productionCoast) || 0),
                                                                0
                                                            );

                                                            const value = Number(totalCost || 0);

                                                            const normalStr = value.toLocaleString("fullwide", {
                                                                useGrouping: false,
                                                                maximumFractionDigits: 20,
                                                            });

                                                            const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);

                                                            return match ? match[0] : "0";
                                                        })()
                                                    }
                                                </th>
                                            </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan={8} className="text-center" style={{ padding: '40px' }}>
                                                    <img
                                                        src="/assest/Images/emptyIcon.svg"
                                                        className="logo-png mt-3"
                                                        style={{ width: "10%" }}
                                                        alt="No data"
                                                    />
                                                    <br />
                                                    {filterLoading ? "Loading..." : "No data available"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {displayData.length > pageSize && (
                                <div
                                    style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    justifyContent: "flex-end"
                                    }}
                                >
                                    <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={displayData.length}
                                    showSizeChanger={false}
                                    showTotal={(total, range) =>
                                        `${range[0]}-${range[1]} of ${total} records`
                                    }
                                    onChange={(page) => {
                                        setCurrentPage(page);
                                    }}
                                    />
                                </div>
                                )}
                            </div>
                        </Card>
                    </div>
                </Content>

                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default WasteReports;